import { LifeBuoyIcon } from 'lucide-react';
import { PageHeader } from '@/components/page-header';
import { useT } from '@/lib/i18n';

/**
 * Support — the last screen here, and now the only one.
 *
 * This file used to hold a generic `<Screen>` placeholder that rendered real
 * chrome around an empty state plus a chip naming the phase that would make it
 * real. Every one of those screens has since been built, and the chip mechanism
 * is deleted with them.
 *
 * Worth recording WHY, because the idea seemed reasonable: a phase number on a
 * placeholder is a claim about a plan, and it went wrong five times. Twice it
 * named a phase that shipped without touching the screen (Settings/Phase 4,
 * Analytics/Phase 7 — and "Analytics" appears nowhere in `07` at all). Three
 * times it was read as a STATUS — "this is broken in phase 5" — rather than a
 * roadmap note. Renaming it "Arrives in Phase N" fixed the grammar and none of
 * the substance.
 *
 * If a placeholder is ever needed again: say what is not built and what it is
 * waiting on. Those are facts that do not expire. A phase number is a promise.
 */
export const Support = () => {
  const t = useT();
  return (
    <div className="mx-auto max-w-3xl">
      <PageHeader
        title={t('nav.support')}
        description={t('support.description')}
      />
      <div className="bg-card rounded-xl border p-6 text-sm">
        <p className="text-muted-foreground">{t('support.body')}</p>
        <div className="mt-4 flex items-center gap-2">
          <LifeBuoyIcon className="text-muted-foreground size-4" />
          {/* An address is not translated, and `dir="ltr"` keeps it from being
              reordered around the `@` when the page runs right-to-left. */}
          <span className="font-mono text-xs" dir="ltr">servicedesk@etcc.gov.ae</span>
        </div>
      </div>
    </div>
  );
};
